import { DEFAULT_APP_CONFIGURATION } from '../consts';
import { IEnv } from '../types';

export function getEnv(): IEnv {
  return DEFAULT_APP_CONFIGURATION.settings;
}
